import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b75b0cce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 0,
  class: "empty"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "unit" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = ["onClick"]

import { ref, onMounted } from 'vue'
import { queryDevicePhysicsLastOnceList } from '@/api'
import { useRouter, useRoute } from 'vue-router'
import { CODE_ENUM } from '@/common'
import moment from 'moment'
import Text from '@/components/text'
import HistoryChart from './history-chart.vue'
import { getDate } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'var-list',
  emits: ['on-data'],
  setup(__props, { emit: $emit }) {



const $route = useRoute()
const router = useRouter()

const deviceId = $route.query.deviceId || ''

// fuck 特殊处理以及处理单位
const formatterMap: any = {
  outerBatVol: ({ value, unit }: any) => {
    const num = Number(value)

    if (num < 4000) {
      return {
        value: '无外部供电',
        unit: '',
      }
    }
    return {
      value,
      unit,
    }
  },
}

const loading = ref(false)

const varList: any = ref([])
const fetchList = async () => {
  loading.value = true
  const res: any = await queryDevicePhysicsLastOnceList({
    gatewayDeviceId: deviceId,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    varList.value = (res.data || []).map((item: any) => {
      const fn = formatterMap[item.code]
      const params = fn ? fn(item) : {}
      return {
        ...item,
        ...params,
      }
    })
  }
}

const formatterTime = (updateTime: any) => {
  return updateTime ? moment(updateTime).format('YYYY-MM-DD HH:mm:ss') : '-'
}

onMounted(() => {
  fetchList()
})

const chartConf = ref({
  visible: false,
  data: {},
})
const handleChart = ({ code, deviceId, statisticsFlag }: any) => {
  if (!statisticsFlag) {
    return
  }
  const time = getDate(3, 'M')
  chartConf.value = {
    visible: true,
    data: {
      time,
      attributeIndexAndDeviceId: code + '-' + deviceId,
    },
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (varList.value.length === 0)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_empty, {
              description: _ctx.$t('D_DATA.noData')
            }, null, 8, ["description"])
          ])), [
            [_directive_loading, loading.value]
          ])
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(varList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list-item ws_mb20",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Text), {
              content: item.name
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name || '-'), 1)
              ]),
              _: 2
            }, 1032, ["content"])
          ]),
          _createElementVNode("p", _hoisted_4, [
            _createVNode(_unref(Text), {
              content: item.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.value || '-'), 1)
              ]),
              _: 2
            }, 1032, ["content"]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.unit), 1)
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('D_DATA.updateTime')) + "：" + _toDisplayString(formatterTime(item.updateTime)), 1),
          _createElementVNode("i", {
            onClick: ($event: any) => (handleChart(item)),
            class: _normalizeClass(["icon-statistics", {
          'icon-statistics-disabled': !item.statisticsFlag,
        }])
          }, null, 10, _hoisted_7)
        ]))
      }), 128))
    ]),
    _createVNode(HistoryChart, {
      visible: chartConf.value.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((chartConf.value.visible) = $event)),
      data: chartConf.value.data
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})